import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ArticleService } from 'app/shared/article.service';
import { UtilisateurService } from 'app/shared/utilisateur.service';
import { catchError, map, of, switchMap } from 'rxjs';
import { ConvertToSlugPipe } from './convert-to-slug.pipe';

export const ArticleResolver = (route: ActivatedRouteSnapshot) => {
  const articleService = inject(ArticleService);
  const utilisateurService = inject(UtilisateurService);
 
  const id = route.paramMap.get('id') || route.params['id'];

  if (!id) return of([null, null, false]);

  return articleService.getArticle(id).pipe(
    switchMap((article) => {
      if (!article) return of([null, null, false]);
      


      return utilisateurService.getUtilisateur(article.auteur).pipe(
        map((auteur) => [article, auteur]),
        catchError(() => of([article, null])),
      );
    }),
    catchError(() => of([null, null, false]))
  );
};

export const NewsResolver = (route: ActivatedRouteSnapshot) => {
  const articleService = inject(ArticleService);
  const utilisateurService = inject(UtilisateurService);
  const id = route.paramMap.get('id') || route.params['id'];

  if (!id) return of([null, null, false]);

  return articleService.getArticle(id).pipe(
    switchMap((article) => {
      if (!article) return of([null, null, false]);
      
   

      return utilisateurService.getUtilisateur(article.auteur).pipe(
        map((auteur) => [article, auteur]),
        catchError(() => of([article, null])),
      );
    }),
    catchError(() => of([null, null, false]))
  );
};